import { render } from "./CombinedPage.vue?vue&type=template&id=35eea324&scoped=true"
import script from "./CombinedPage.vue?vue&type=script&lang=js"
export * from "./CombinedPage.vue?vue&type=script&lang=js"

import "./CombinedPage.vue?vue&type=style&index=0&id=35eea324&scoped=true&lang=css"
import "./CombinedPage.vue?vue&type=style&index=1&id=35eea324&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35eea324"]])

export default __exports__